
import { MapLocation } from '@/types/location';

// Vitality Club Gym Locations
export const vitalityClubGyms: MapLocation[] = [
  {
    id: 27001,
    name: "Vitality Club - Riyadh (An Nakheel)",
    type: "Gym",
    devices: 5,
    coordinates: [24.725943735139495, 46.62737893068252],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-41",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 27002,
    name: "Vitality Club - Riyadh (Ar Rawdah)",
    type: "Gym",
    devices: 5,
    coordinates: [24.731159993623493, 46.78561437301188],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-42",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 27003,
    name: "Vitality Club - Riyadh (Ar Rabie)",
    type: "Gym",
    devices: 5,
    coordinates: [24.79468748592331, 46.65530776074876],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-43",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 27004,
    name: "Vitality Club - Riyadh (Al Manar)",
    type: "Gym",
    devices: 5,
    coordinates: [24.73109537583329, 46.78550121959932],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-44",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 27005,
    name: "Vitality Club - Riyadh (Ishbiliyah)",
    type: "Gym",
    devices: 5,
    coordinates: [24.791380570189002, 46.78825537301187],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-45",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 27006,
    name: "Vitality Club - Riyadh (Al Rawabi)",
    type: "Gym",
    devices: 5,
    coordinates: [24.79814532021481, 46.79273444718158],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
